import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg
      ref={ref}
      onClick={onClick}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      data-testid='remove-button-svg'>
      <path d='M5 7H6.55556H19' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M9.02081 7.2V5.6C9.02081 5.17565 9.17719 4.76869 9.45555 4.46863C9.7339 4.16857 10.1114 4 10.5051 4H13.4737C13.8673 4 14.2449 4.16857 14.5232 4.46863C14.8016 4.76869 14.958 5.17565 14.958 5.6V7.2M17.1844 7.2V18.4C17.1844 18.8243 17.028 19.2313 16.7497 19.5314C16.4713 19.8314 16.0938 20 15.7001 20H8.27866C7.885 20 7.50747 19.8314 7.22911 19.5314C6.95075 19.2313 6.79437 18.8243 6.79437 18.4V7.2H17.1844Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M10 11V16' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14 11V16' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
});

export default React.memo(Icon);
